<!--
Use ngx-loading-bar/http-client when load this page.
-->
<ngx-loading-bar [color]="'white'"></ngx-loading-bar>

<div class="bg-white">
  <div>
    <!--
      Mobile filter dialog    -->
    <div id="mobile-menu" class="relative z-40 hidden lg:hidden" role="dialog" aria-modal="true">
      <div class="fixed inset-0 bg-black bg-opacity-25"></div>
      <div class="fixed inset-0 z-40 flex">
        <div class="relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white py-4 pb-12 shadow-xl">
          <div class="flex items-center justify-between px-4">
            <h2 class="text-lg font-medium text-gray-900">Filtros</h2>
            <button (click)="menuOverlay()" type="button" class="-mr-2 flex h-10 w-10 items-center justify-center rounded-md bg-white p-2 text-gray-400">
              <span class="sr-only">Fechar menu</span>
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <!-- Filters -->
          <form class="mt-4 border-t border-gray-200">
            <ng-container *ngIf="search.category !== undefined || search.salesman !== undefined">
              <div class="flex justify-end px-4 pt-4">
                <button (click)="clearFilters()" class="uppercase text-xs font-semibold text-pink-800 hover:text-pink-900">Limpar Filtros</button>
              </div>
            </ng-container>
            <div class="px-4 py-6">
              <h3 class="-mx-2 -my-3 flow-root">
                <!-- Expand/collapse section button -->
                <button (click)="filterOption('filter-section-mobile-0', 'category-arrow-mobile')" type="button" class="flex w-full items-center justify-between bg-white px-2 py-3 text-gray-400 hover:text-gray-500" aria-controls="filter-section-mobile-0" aria-expanded="false">
                  <span class="font-medium text-gray-900">Categorias</span>
                  <span class="ml-6 flex items-center">
                    <svg id="category-arrow-mobile" class="rotate-180 h-5 w-5 transform" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </button>
              </h3>
              <!-- Filter section, show/hide based on section state. -->
              <div class="pt-6 block" id="filter-section-mobile-0">
                <ng-container *ngIf="searchResults?.facetDistribution?.categories == undefined">
                  <div class="flex flex-col space-y-2">
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                  </div>
                </ng-container>

                <div class="space-y-6">
                  <ng-container *ngFor="let item of searchResults?.facetDistribution?.categories">
                    <div class="flex items-center space-x-2">
                      <input
                        name="category_mobile"
                        [checked]="clientMarketplaceCoreProductServiceCheckHaystackIsFiltering('category',item)"
                        (click)="clientMarketplaceCoreProductServiceChecCategorykHaystack('clientMarketplaceCoreProductServiceCheckHaystackCategoryMobile')"
                        value="{{item.index}}"
                        id="item.id"
                        type="checkbox"
                        class="clientMarketplaceCoreProductServiceCheckHaystackCategoryMobile h-4 w-4 rounded border-gray-300 text-pink-800 focus:ring-pink-900"
                      />
                      <label class="ml-3 text-sm text-gray-600 truncate"> {{item.index}} </label>
                      <div class="relative inline-flex items-center p-2 text-xs font-semibold text-center text-white">
                        <div class="absolute inline-flex items-center justify-center w-6 h-6 text-[11px] font-semibold text-pink-800 bg-pink-50 border border-pink-800 rounded-md -top-2 -right-2">{{item.value}}</div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="border-t border-gray-200 px-4 py-6">
              <h3 class="-mx-2 -my-3 flow-root">
                <!-- Expand/collapse section button -->
                <button (click)="filterOption('filter-section-mobile-1', 'salesman-arrow-mobile')" type="button" class="flex w-full items-center justify-between bg-white px-2 py-3 text-gray-400 hover:text-gray-500" aria-controls="filter-section-mobile-1" aria-expanded="false">
                  <span class="font-medium text-gray-900">Marcas</span>
                  <span class="ml-6 flex items-center">
                    <svg id="salesman-arrow-mobile" class="rotate-180 h-5 w-5 transform" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </button>
              </h3>
              <!-- Filter section, show/hide based on section state. -->
              <div class="pt-6 block" id="filter-section-mobile-1">
                <ng-container *ngIf="searchResults?.facetDistribution?.salesman == undefined">
                  <div class="flex flex-col space-y-2">
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                  </div>
                </ng-container>
                <div class="space-y-6">
                  <ng-container *ngFor="let item of searchResults?.facetDistribution?.salesman">
                    <div class="flex items-center space-x-2">
                      <input
                        [checked]="clientMarketplaceCoreProductServiceCheckHaystackIsFiltering('salesman',item)"
                        (click)="clientMarketplaceCoreProductServiceCheckSalesmanHaystack('clientMarketplaceCoreProductServiceCheckHaystackSalesmanMobile')"
                        value="{{item.index}}"
                        type="checkbox"
                        class="clientMarketplaceCoreProductServiceCheckHaystackSalesmanMobile h-4 w-4 rounded border-gray-300 text-pink-800 focus:ring-pink-900"
                      />
                      <label class="ml-3 text-sm text-gray-600 truncate"> {{item.index}} </label>
                      <div class="relative inline-flex items-center p-2 text-xs font-semibold text-center text-white">
                        <div class="absolute inline-flex items-center justify-center w-6 h-6 text-[11px] font-semibold text-pink-800 bg-pink-50 border border-pink-800 rounded-md -top-2 -right-2">{{item.value}}</div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <main class="mx-auto max-w-7xl px-4">
      <div class="flex items-baseline justify-between border-b border-gray-200 pb-6 pt-12">
        <ng-container *ngIf="search.query !== undefined && search.query != ''">
          <p class="text-sm sm:text-base font-medium text-gray-800">{{search.query | uppercase}}</p>
        </ng-container>
        <ng-container *ngIf="search.query === undefined && search.query == ''">
          <div class="text-sm sm:text-base font-medium text-gray-800"></div>
        </ng-container>
        <ng-container *ngIf="(search.query === undefined || search.query == '') && search.category != ''"> <p class="text-sm sm:text-base font-medium text-gray-800">{{search.category}}</p> </ng-container>

        <div class="flex items-center">
          <div class="relative inline-block text-left">
            <div>
              <button (click)="orderByOptions()" type="button" class="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900" id="menu-button" aria-expanded="false" aria-haspopup="true">
                Mostrar
                <svg class="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
                </svg>
              </button>
            </div>
            <div id="order-by" class="hidden absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
              <div class="py-1" role="none">
                <a [ngClass]="{'font-medium text-gray-900': search.order_by == 'sales'}" [routerLink]="[]" [queryParams]="{order_by: 'sales'}" queryParamsHandling="merge" class="text-gray-500 block px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-0">Mais vendidos</a>
                <a [ngClass]="{'font-medium text-gray-900': search.order_by == 'price,asc'}" [routerLink]="[]" [queryParams]="{order_by: 'price,asc'}" queryParamsHandling="merge" class="text-gray-500 block px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-1">Menor preço</a>
                <a [ngClass]="{'font-medium text-gray-900': search.order_by == 'price,desc'}" [routerLink]="[]" [queryParams]="{order_by: 'price,desc'}" queryParamsHandling="merge" class="text-gray-500 block px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-2">Maior preço</a>
              </div>
            </div>
          </div>

          <button (click)="menuOverlay()" type="button" class="-m-2 ml-4 p-2 text-gray-400 hover:text-gray-500 sm:ml-6 lg:hidden">
            <span class="sr-only">Filtros</span>
            <svg class="h-5 w-5" aria-hidden="true" viewBox="0 0 20 20" fill="currentColor">
              <path
                fill-rule="evenodd"
                d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 01.628.74v2.288a2.25 2.25 0 01-.659 1.59l-4.682 4.683a2.25 2.25 0 00-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 018 18.25v-5.757a2.25 2.25 0 00-.659-1.591L2.659 6.22A2.25 2.25 0 012 4.629V2.34a.75.75 0 01.628-.74z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>

      <section aria-labelledby="products-heading" class="pb-24 pt-6">
        <h2 id="products-heading" class="sr-only">Produtos</h2>

        <div class="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4">
          <!-- Filters -->
          <form class="hidden lg:block">
            <ng-container *ngIf="search.category !== undefined || search.salesman !== undefined">
              <div class="flex justify-end">
                <button (click)="clearFilters()" class="uppercase text-xs font-semibold text-pink-800 hover:text-pink-900">Limpar Filtros</button>
              </div>
            </ng-container>
            <div class="border-b border-gray-200 py-6">
              <h3 class="-my-3 flow-root">
                <!-- Expand/collapse section button -->
                <button (click)="filterOption('filter-section-0', 'category-arrow')" type="button" class="flex w-full items-center justify-between bg-white py-3 text-sm text-gray-400 hover:text-gray-500" aria-controls="filter-section-0" aria-expanded="false">
                  <span class="font-medium text-gray-900">Categorias</span>
                  <span class="ml-6 flex items-center">
                    <svg id="category-arrow" class="rotate-180 h-5 w-5 transform" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </button>
              </h3>
              <!-- Filter section, show/hide based on section state. -->
              <div class="pt-6 block" id="filter-section-0">
                <ng-container *ngIf="searchResults?.facetDistribution?.categories == undefined">
                  <div class="flex flex-col space-y-2">
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                  </div>
                </ng-container>
                <div class="space-y-6">
                  <ng-container *ngFor="let item of searchResults?.facetDistribution?.categories">
                    <div class="flex items-center space-x-2">
                      <input
                        [checked]="clientMarketplaceCoreProductServiceCheckHaystackIsFiltering('category',item)"
                        (click)="clientMarketplaceCoreProductServiceChecCategorykHaystack('clientMarketplaceCoreProductServiceCheckHaystackCategory')"
                        value="{{item.index}}"
                        id="item.id"
                        type="checkbox"
                        class="clientMarketplaceCoreProductServiceCheckHaystackCategory h-4 w-4 rounded border-gray-300 text-pink-800 focus:ring-pink-900"
                      />
                      <label class="ml-3 text-sm text-gray-600 truncate"> {{item.index}} </label>
                      <div class="relative inline-flex items-center p-2 text-xs font-semibold text-center text-white">
                        <div class="absolute inline-flex items-center justify-center w-6 h-6 text-[11px] font-semibold text-pink-800 bg-pink-50 border border-pink-800 rounded-md -top-2 -right-2">{{item.value}}</div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="border-b border-gray-200 py-6">
              <h3 class="-my-3 flow-root">
                <!-- Expand/collapse section button -->
                <button (click)="filterOption('filter-section-1', 'salesman-arrow')" type="button" class="flex w-full items-center justify-between bg-white py-3 text-sm text-gray-400 hover:text-gray-500" aria-controls="filter-section-1" aria-expanded="false">
                  <span class="font-medium text-gray-900">Marcas</span>
                  <span class="ml-6 flex items-center">
                    <svg id="salesman-arrow" class="rotate-180 h-5 w-5 transform" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </button>
              </h3>
              <!-- Filter section, show/hide based on section state. -->
              <div class="pt-6 block" id="filter-section-1">
                <ng-container *ngIf="searchResults?.facetDistribution?.salesman == undefined">
                  <div class="flex flex-col space-y-2">
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                    <p-skeleton width="100%" height="1rem" borderRadius="2px"></p-skeleton>
                  </div>
                </ng-container>
                <div class="space-y-6">
                  <ng-container *ngFor="let item of searchResults?.facetDistribution?.salesman">
                    <div class="flex items-center space-x-2">
                      <input
                        [checked]="clientMarketplaceCoreProductServiceCheckHaystackIsFiltering('salesman',item)"
                        (click)="clientMarketplaceCoreProductServiceCheckSalesmanHaystack('clientMarketplaceCoreProductServiceCheckHaystackSalesman')"
                        value="{{item.index}}"
                        type="checkbox"
                        class="clientMarketplaceCoreProductServiceCheckHaystackSalesman h-4 w-4 rounded border-gray-300 text-pink-800 focus:ring-pink-900"
                      />
                      <label class="ml-3 text-sm text-gray-600 truncate"> {{item.index}} </label>
                      <div class="relative inline-flex items-center p-2 text-xs font-semibold text-center text-white">
                        <div class="absolute inline-flex items-center justify-center w-6 h-6 text-[11px] font-semibold text-pink-800 bg-pink-50 border border-pink-800 rounded-md -top-2 -right-2">{{item.value}}</div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </form>

          <!-- Product grid -->
          <div class="col-span-1 lg:col-span-3">
            <ng-container *ngIf="!searchResults?.data">
              <div class="flex flex-nowrap flex-col justify-center items-center gap-6 sm:gap-0 sm:py-4 sm:grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 sm:gap-x-6 sm:gap-y-6 sm:space-x-0">
                <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
                <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
                <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
                <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
                <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
                <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
                <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
                <p-skeleton width="100%" height="20rem" borderRadius="6px"></p-skeleton>
              </div>
            </ng-container>
            <ng-container *ngIf="searchResults?.total > 0">
              <ng-container *ngIf="searchResults?.data">
                <div class="sm:py-4 flex justify-center">
                  <div class="w-full">
                    <ul role="list" class="flex flex-nowrap flex-col justify-center items-center gap-6 sm:items-stretch sm:gap-0 sm:py-4 sm:grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 sm:gap-x-6 sm:gap-y-6 sm:space-x-0">
                      <ng-container *ngFor="let product of searchResults?.data;">
                        <IncludeProductContainer [cart]="cart" [product]="product"></IncludeProductContainer>
                      </ng-container>
                    </ul>
                  </div>
                </div>
                <pagination (fncDataIndex)="clientMarketplaceCoreProductServiceIndex($event)" [meta]="searchResults" [paginantion_type]="'normal'"></pagination>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="searchResults?.total == 0">
              <div class="flex flex-col justify-center items-center mt-8">
                <p class="text-xl font-bold text-gray-900">Ops! Nenhum resultado encontrado</p>
                <p class="text-sm text-gray-600">Tente aplicar um número menor de filtros</p>
              </div>
            </ng-container>
          </div>
        </div>
      </section>
    </main>
  </div>
</div>
